// Reusable budget validation utility

export interface BudgetValidationResult {
  isValid: boolean;
  minError?: string;
  maxError?: string;
}

export function validateBudgetRange(budgetMin: number, budgetMax: number): BudgetValidationResult {
  const result: BudgetValidationResult = { isValid: true };

  // Check if min is provided and valid
  if (!budgetMin || budgetMin <= 0) {
    result.minError = 'Minimum budget is required and must be greater than 0';
    result.isValid = false;
  }

  // Check if max is provided and valid
  if (!budgetMax || budgetMax <= 0) {
    result.maxError = 'Maximum budget is required and must be greater than 0';
    result.isValid = false;
  }

  // Check if min is less than max (only if both are valid)
  if (budgetMin > 0 && budgetMax > 0 && budgetMin >= budgetMax) {
    result.minError = 'Minimum must be less than maximum';
    result.maxError = 'Maximum must be greater than minimum';
    result.isValid = false;
  }

  return result;
}

// Helper to get budget range error message (for simple display)
export function getBudgetRangeError(budgetMin: number, budgetMax: number): string | null {
  if (budgetMin > 0 && budgetMax > 0 && budgetMin >= budgetMax) {
    return 'Minimum budget cannot be higher than maximum budget';
  }
  return null;
}